import React, { useState, useEffect } from "react";
import { Container, Row, Col, Ratio } from "react-bootstrap";
import RightFooter from "../common/RightFooter";
import t from "../../Utils/Translation";
import Tooltip from '@mui/material/Tooltip';
import LykioButton from "../common/LykioButton";
import Card from 'react-bootstrap/Card';
import { useNavigate } from "react-router-dom";
import MultiActionAreaCard from "./MultiActionAreaCard";
import { textTransform } from "@mui/system";
import {
	AUTHORIZED_URL_PREFIX,
	AxiosConfig
} from '../../Utils/Constants';
import Loading from './../common/Loading';
import axios from 'axios';


const Quizzes = () => {
    const [ isLoading, setIsLoading ] = useState(true);
    const [unitUsage, setUnitUsage] = useState([]);
  
    useEffect(() => {
          const fetchUnitUsage = async () => {
              try {
                  const { data } = await axios.post(`${AUTHORIZED_URL_PREFIX}${"/user/getResultsByType"}`,{type: 'Quiz'}, AxiosConfig());
                  setUnitUsage(data.unitUsage);
                  console.log(data.unitUsage);
                  setIsLoading(false);
                  if (!data.success) {
                      console.log('error')
                  }
              } catch (error) {
                  console.log(error);
              }
          };
          fetchUnitUsage();
          
      }, []);
  const navigate = useNavigate();

  return (
    <div className="lykioccs-main-content lykiocss-Quiz">
       {isLoading ? <Loading/> : <>
       <Container className="lykiocss-margin-top-5em">
        <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                <div style={{background: "linear-gradient(to bottom, #9741b4, #e49ffc)",textAlign:'center', color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'50em'}} className="lykiocss-center">
                    {t('Evaluate your knowledge about biases and their importance in the recruitment process.')} &nbsp;
                    {t("If you feel you're missing some information, please go to the \"Insights\" section. There you will find everything you need. At the end of the activity, you will receive feedback on your performance. Good luck and safe travels on the Biasfree SpaceShuttle!")}
                </div>
        </Row>
       </Container>
       <Container>
        <Row style={{marginTop:'4em'}}>
            <Col style={{ marginBottom: '1.5rem' }}>
                <MultiActionAreaCard completed={false}
                width={'26rem'} height={'29rem'} t={t} text={t('Start')} duration={5} level={"basic"} game={true} title={t("Quiz - Unconscious Cognitive Biases").toUpperCase()} backgroundColor="#9741b4" lightBackgroundColor="#e49ffc" id={1} openInIframe={true}
                cover={unitUsage.filter((item) => item.unitId==='q001').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/QUIZ1-BIAS+COGNITIVI+INCONSCI.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/quiz001.png"}  comingSoon={true}/>
            </Col>

            <Col style={{ marginBottom: '1.5rem' }}>
                <MultiActionAreaCard completed={false}
                width={'26rem'} height={'29rem'} t={t} text={t('Start')} duration={5} level={"advanced"} game={true} title={t("Practice identifying linguistic biases in your job postings").toUpperCase()} backgroundColor="#9741b4" lightBackgroundColor="#e49ffc" id={2} openInIframe={true} 
                cover={unitUsage.filter((item) => item.unitId==='q002').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/QUIZ2-ESERCITATI+AD+INIVIDIUARE+I+BIAS+LINGUISTICI+NEGLI+ANNUNCI+DI+LAVORO.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/quiz002.jpg"}  comingSoon={true}/>
            </Col>

            <Col style={{ marginBottom: '1.5rem' }}>
                <MultiActionAreaCard completed={false}
                width={'26rem'} height={'29rem'} t={t} text={t('Start')} duration={5} level={"basic"} game={true} title={t("What is Steve's profession?").toUpperCase()} backgroundColor="#9741b4" lightBackgroundColor="#e49ffc" id={3} openInIframe={true} 
                cover={unitUsage.filter((item) => item.unitId==='q003').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/QUIZ3-QUAL+E'+IL+MESTIERE+DI+STEVE.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/quiz003.jpg"} comingSoon={true}/>
            </Col>
        </Row>
        <Row style={{marginTop:'3em'}}>
            <Col style={{ marginBottom: '1.5rem' }}>
                <MultiActionAreaCard completed={false}
                width={'26rem'} height={'29rem'} t={t} text={t('Start')} duration={5} level={"advanced"} game={true} title={t("Quiz - Biased or unbiased?").toUpperCase()} backgroundColor="#9741b4" lightBackgroundColor="#e49ffc" id={4} openInIframe={true} 
                cover={unitUsage.filter((item) => item.unitId==='q004').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/QUIZ4-BIASED+O+NON+BIASED.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/quiz004.jpg"} comingSoon={true}/>
            </Col>
            <Col style={{ marginBottom: '1.5rem' }}>
                <MultiActionAreaCard completed={false}
                width={'26rem'} height={'29rem'} t={t} text={t('Start')} duration={5} level={"advanced"} game={true} title={t("Quiz - Inclusive recruitment: how much do you know?").toUpperCase()} backgroundColor="#9741b4" lightBackgroundColor="#e49ffc" id={5} openInIframe={true} 
                cover={unitUsage.filter((item) => item.unitId==='q005').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/QUIZ5-RECRUITMENT+INCLUSIVO_+QUANTO+NE+SAI.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/quiz005.jpg"} comingSoon={true}/>
            </Col>
            <Col style={{ marginBottom: '1.5rem' }}>
                <MultiActionAreaCard completed={false}
                width={'26rem'} height={'29rem'} t={t} text={t('Start')} duration={5} level={"advanced"} game={true} title={t("Quiz - How much do biases impact the recruitment?").toUpperCase()} backgroundColor="#9741b4" lightBackgroundColor="#e49ffc" id={6} openInIframe={true} 
                cover={unitUsage.filter((item) => item.unitId==='q006').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/QUIZ6-IMPATTO_BIAS_SELEZIONE.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/quiz6_cover.jpg"} comingSoon={true}/>
            </Col>
        </Row>
       </Container>
       </>}
      <RightFooter />
    </div>
  );
};

export default Quizzes;